import { Heading } from 'blaze-ui/Heading/Heading'
import { Paragraph } from 'blaze-ui/Paragraph/Paragraph'
import { CreateIntegrationPanelProps } from 'screens/BrandKit/LinkedAccountsDrawer/Types'
import { Button } from 'blaze-ui/Button'
import { Facebook, Instagram, LinkedIn, ArrowRight } from 'blaze-ui/icons'
import Styles from './CreateIntegrationPanel.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { sendMessageToNativeApp } from 'utils/sendMessageToNativeApp'

export const CreateIntegrationPanel = ({
  onSelectFacebook,
  onSelectInstagram,
  onSelectLinkedIn,
}: CreateIntegrationPanelProps) => {
  const { isIOSNative } = useResponsiveDesign()

  const handleGoToIntegrations = () => {
    sendMessageToNativeApp('goToIntegrations')
  }

  return (
    <div className={Styles.root}>
      <div className={Styles.contentWrapper}>
        <div>
          <div>
            <Facebook size={40} />
            <Instagram size={40} />
            <LinkedIn size={40} />
          </div>
          <div className={Styles.description}>
            <Heading level={3}>Connect your Brand Kit to a new social media account.</Heading>
            <Paragraph color="var(--dark-60)">
              Let Blaze analyze your social media posts to create content that perfectly matches your brand voice.
            </Paragraph>
          </div>
        </div>
        <div className={Styles.buttons}>
          {isIOSNative ? (
            <Button
              fullWidth
              variant="tertiary"
              size="lg"
              onPress={handleGoToIntegrations}
              endIcon={ArrowRight}
              aria-label="Go to Integrations"
            >
              Go to Integrations
            </Button>
          ) : (
            <>
              <Button
                fullWidth
                variant="tertiary"
                size="lg"
                onPress={onSelectFacebook}
                frontIcon={Facebook}
                aria-label="Connect Facebook Business"
              >
                Connect Facebook Business
              </Button>
              <Button
                fullWidth
                variant="tertiary"
                size="lg"
                onPress={onSelectInstagram}
                frontIcon={Instagram}
                aria-label="Connect Instagram Business"
              >
                Connect Instagram Business
              </Button>
              <Button
                fullWidth
                variant="tertiary"
                size="lg"
                frontIcon={LinkedIn}
                aria-label="Connect LinkedIn"
                onPress={onSelectLinkedIn}
              >
                Connect LinkedIn
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
